import React from "react";
import SoftBox from "../SoftBox";

/** CyberPay wordmark from the approved merchant portal reference. */
export default function Brand() {
  return (
    <SoftBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "baseline",
        color: "#0b0b0c",
        fontSize: 27,
        fontWeight: 800,
        letterSpacing: "-0.065em",
        lineHeight: 1.2,
        whiteSpace: "nowrap",
      }}
    >
      Cyber
      <SoftBox
        component="span"
        sx={{
          position: "relative",
          isolation: "isolate",
          "&::after": {
            content: '""',
            position: "absolute",
            zIndex: -1,
            inset: "auto -2px -1px -1px",
            height: 5,
            backgroundColor: "#c6f03a",
            transform: "rotate(-3deg)",
          },
        }}
      >
        Pay
      </SoftBox>
    </SoftBox>
  );
}
